import { createFileRoute } from "@tanstack/react-router";

import { Expense } from "~/components/feature/results/components";

export const Route = createFileRoute("/_app/dashboard/results/expense/")({
  component: RouteComponent,
});

function RouteComponent() {
  return <Expense />;
}
